import { useMutation } from '@tanstack/react-query';
import { loginBusinessStripeAccount } from '../../services/business';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';

function useLoginStripeAccount() {
  const { user } = useUser<LoadedUser>();

  return useMutation({
    mutationFn: async () => {
      if (!user?.business?.id) return null;
      const result = await loginBusinessStripeAccount(user.business.id);
      return result;
    },
  });
}

export default useLoginStripeAccount;
